import { addDict, isLang, SOURCE_LANG, type Dict } from './i18n';

/*
 * Translation files, one JSON per language (Turkish source text → translation).
 * Loaded on demand: the browser fetches only the chosen language, the server
 * bundles all of them.
 */

const LOADERS: Record<string, () => Promise<{ default: Dict }>> = {
  en: () => import('./locales/en.json'),
  zh: () => import('./locales/zh.json'),
  hi: () => import('./locales/hi.json'),
  es: () => import('./locales/es.json'),
  fr: () => import('./locales/fr.json'),
  ar: () => import('./locales/ar.json'),
  pt: () => import('./locales/pt.json'),
  ru: () => import('./locales/ru.json'),
  de: () => import('./locales/de.json'),
  ja: () => import('./locales/ja.json'),
};

/** Makes sure the translations of a language are registered. */
const loaded = new Set<string>([SOURCE_LANG]);

export async function loadLang(code: string): Promise<void> {
  if (!isLang(code) || loaded.has(code) || !LOADERS[code]) return;
  addDict(code, (await LOADERS[code]()).default);
  loaded.add(code);
}

export async function loadAllLangs(): Promise<void> {
  await Promise.all(Object.keys(LOADERS).map(loadLang));
}
